import { Typography } from '@breezeventures/ui-kit/typography';

export const OtpError = () => (
  <div role="alert" className="w-full rounded-xs bg-yellow-500/10 p-3 text-xs">
    <Typography.Text size="m" weight="medium">
      Something went wrong
    </Typography.Text>
    <Typography.Text size="s" color="secondary">
      Please try again later
    </Typography.Text>
  </div>
);
